module.exports = __webpack_public_path__ + "static/9-0e8121a5d38255548e1bed793c2754bc.jpg";